export const environment = {
  production: true,
  base_url: window.location.protocol + "//" + window.location.host,
};
